<div class="bg-image"></div>

<div class="d-flex overflow-hidden" [ngClass]="
    isMobile
      ? 'flex-column justify-content-start'
      : 'flex-row justify-content-center'
  " style="height: calc(100vh - 60px); position: relative; z-index: 100">
  <!-- <app-custom-stepper [stepCount]="3" [selectedStep]="selectedStep"></app-custom-stepper> -->

  <div class="w-100" *ngIf="selectedStep === steps.chooseProduct">
    <app-purchase-new-app [(subscriptionState)]="subscriptionState" [(selectedBillingCycle)]="selectedBillingCycle"
      [selectedCurrency]="selectedCountryCurrency" (goForward)="calculateSummaryGoGorward()">
    </app-purchase-new-app>
  </div>

  <div class="add-organisation-container m-auto rounded-4" *ngIf="selectedStep === steps.addOrganisation">
    <app-add-organisation class="w-100" width="100%" boxShadow="none" [organizationDetails]="organizationDetails"
      (saveOrganizationDetails)="goForward($event)" (goBack)="goBack($event)"
      [isMobile]="isMobile"></app-add-organisation>
  </div>

  <div *ngIf="selectedStep === steps.addOrganisation" style="width: 25%" (click)="changeSummaryVisibility()"
    class="order-summary-container my-auto d-flex flex-column {{isSummarySidebarHidden ? 'hide' : ''}}">
    <span class="d-flex flex-row justify-content-between align-items-center">
      <h4 class="fw-semibold m-0">Order Summary</h4>
      <!-- <span class="material-icons-outlined">shopping_cart</span> -->
      <!-- <div class="d-flex flex-row align-items-center gap-1 gap-sm-2">
        <span class="material-icons-outlined text-success" title="Selected Currency">
          currency_exchange
        </span>
        <dx-select-box (click)="$event.stopPropagation()" style="width: 74px;" [items]="countryCurrency" displayExpr="displayExpr" valueExpr="currency"
          [(value)]="selectedCountryCurrency" (onValueChanged)="selectedCountryCurrencyChanged()"
          class="selectedCountryCurrency" id="selectedCountryCurrency"></dx-select-box>
      </div> -->
    </span>
    <hr />
    <div *ngFor="let plan of selectedPlans"
      class="d-flex flex-column align-content-start mb-2 overflow-auto custom-hidden-scrollbar">
      <div class="d-flex justify-content-between">
        <div>
          <p class="fs-5 appName mb-0">{{ appNames[plan.productType] }}</p>
          <p class="planName">
            {{
            plan.name +
            (plan.unlimitedUsers
            ? " - Unlimited Users"
            : " - Upto " + plan.numberOfUsers + (plan.numberOfUsers === 1 ? " user" : " users"))
            }}
          </p>
        </div>
        <div class="d-flex flex-column">
          <p class="price m-0">
            {{ plan.rate | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
            selectedBillingCycle === "Monthly" ? "mo" : "yr"
            }}
          </p>
          <span *ngIf="plan.numberOfTrialDays > 0" class="trial-days mt-1">
            {{plan.numberOfTrialDays}} Days Free!
          </span>
        </div>
      </div>
      <app-selected-app-description [selectedApp]="plan.productType" [showBulletPoints]="true"
        [showDescription]="false">
      </app-selected-app-description>
    </div>

    <div class="mt-auto bg-whitesmoke rounded p-3 d-flex justify-content-between align-items-center"
      *ngIf="totalCost !== 0">
      <p class="fs-5 fw-bold mb-0">Net Total</p>
      <!-- <hr class="mt-1 mb-1" /> -->
      <div class="total align-self-end">
        <span class="price fw-bold" style="font-size: 18px;color: green">
          {{ totalCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
          selectedBillingCycle === "Monthly" ? "mo" : "yr"
          }}
        </span>
      </div>
    </div>
  </div>

  <!-- <div
    class="plans-container d-flex justify-content-center w-100"
    *ngIf="selectedStep === steps.chooseApp">
    <app-app-selector
      [subscriptionState]="subscriptionState"
      (selectedAppChanged)="selectedAppChanged($event)"
      (backTriggered)="goBack()"
      (nextTriggered)="decideNextStep()"></app-app-selector>
  </div> -->

  <!-- <div
    class="plans-container d-flex justify-content-center w-100"
    *ngIf="selectedStep === steps.chooseSketch">
    <app-sketch-variant-selector
      class="skecth-selector"
      [showBackButton]="true"
      [selectedSoftware]="subscriptionState.selectedApp"
      [mode]="'new-organization'"
      (backTriggered)="goBack()"
      (next)="changeSketchVariant($event)"
      style="background-color: white"></app-sketch-variant-selector>
  </div> -->

  <!-- <div
    class="plans-container d-flex justify-content-center w-100"
    *ngIf="selectedStep === steps.plans">
    <app-plan-selector
      [subscriptionState]="subscriptionState"
      (subscriptionStateChanged)="subscriptionStateChanged($event)"
      [selectedCountryCurrency]="selectedCountryCurrency"
      [subscriptionBillingCycle]="selectedBillingCycle"
      (onBillingCycleChanged)="onBillingCycleChanged($event)"
      (saveTriggered)="selectedStep = selectedStep + 1"
      (sketchAppChanged)="
        selectedPlans = $event.selectedPlans; totalCost = $event.totalCost
      "
      [width]="'100%'"
      (backTriggered)="goBack()"
      [mode]="'new-organization'"></app-plan-selector>
  </div> -->

  <ng-container *ngIf="selectedStep === steps.summary">
    <div class="d-flex flex-column overflow-auto order-summary-page p-sm-4">
      <div class="d-flex gap-2 flex-column-reverse flex-sm-row h-100">
        <div class="border-en d-flex flex-column col-sm-7 p-4 rounded bg-whitesmoke no-border-en" style="line-height: 28px">
          <h3 class="text-center fw-bold" style="margin-bottom: 2rem;">Checkout</h3>
          <div *ngFor="let plan of selectedPlans" class="mb-4">
            <div class="d-flex flex-column">
              <div class="d-flex mb-2 justify-content-between">
                <div>
                  <h5 class="mb-1 fw-bold appName" title="Selected Product">
                    {{ appNames[plan.productType] }}
                  </h5>
                  <span class="text-muted mb-0">
                    {{ plan.name }}
                    {{
                    plan.unlimitedUsers
                    ? " - Unlimited Users"
                    : " - For " + plan.numberOfUsers + (plan.numberOfUsers === 1 ? " user" : " users")
                    }}
                  </span>
                </div>
                <h5 class="mb-0">
                  {{ plan.rate | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                  selectedBillingCycle === "Monthly" ? "mo" : "yr"
                  }}
                </h5>
              </div>
              <app-selected-app-description [selectedApp]="plan.productType" [showBulletPoints]="false"
                [showDescription]="false">
              </app-selected-app-description>
            </div>


            <!-- <div class="mt-3" *ngIf="!plan.unlimitedUsers">
                        <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex flex-column">
                            <div>
                                <span>Add-on Users</span>
                                <button id="info-button" class="d-inline info-button">
                                    <span class="material-icons-outlined">
                                        info
                                    </span>
                                </button>
                            </div>
                            <div class="d-inline">
                                <div class="d-inline-flex gap-2 align-items-center">
                                    <button
                                        class="icon-button"
                                        (click)="updateAddOnUsers(plan, 1)">
                                        <span class="material-icons-outlined plus">
                                            add_circle_outline
                                        </span>
                                    </button>
                                    <dx-number-box
                                        [(value)]="plan.addOnCount"
                                        (onValueChanged)="updateAddOnUsers(plan, 0, $event)"
                                        [min]="0"
                                        [max]="100"
                                        width="35px"
                                        class="text-center">
                                    </dx-number-box>
                                    <button
                                        (click)="updateAddOnUsers(plan, -1)"
                                        class="icon-button">
                                        <span class="material-icons-outlined">
                                            remove_circle_outline
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="ms-auto" *ngIf="plan.addOnCount > 0">
                            <h5 class="mb-0">+{{plan.addOnCost}} {{selectedCountryCurrency}}/{{selectedBillingCycle === 'Monthly' ? 'month': 'year'}}</h5>
                            <p class="text-muted mb-0">
                                ({{plan.addOnCount}} * {{plan.addOnRate}} {{selectedCountryCurrency}}/user)
                            </p>
                        </div>
                        <dx-popover
                            target="#info-button"
                            showEvent="mouseover touchstart"
                            hideEvent="mouseout touchend">
                            <div *dxTemplate="let data of 'content'">
                                <ng-container *ngFor="let slab of getAddOnUserPricing(plan)">
                                    <p class="mb-0">{{ slab }}</p><br />
                                </ng-container>
                            </div>

                        </dx-popover>
                        </div>
                     </div> -->
          </div>

          <div class="border-top pt-3 mt-auto">
            <div class="d-flex justify-content-between">
              <h4 class="fw-bold">Net Total</h4>
              <h4 class="fw-bold" style="color: #004300;">
                {{ totalCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                selectedBillingCycle === "Monthly" ? "mo" : "yr"
                }}
              </h4>
            </div>
          </div>
        </div>

        <div
          class="mb-3 d-flex flex-column justify-content-between bg-whitesmoke rounded mb-sm-0 col-sm-5 p-3 ps-sm-4">
          <div class="d-flex flex-column">
            <h4 class="mb-3 fw-bold">Organization Details</h4>
            <div>
              <p class="mb-2">
                <strong>Name:</strong>
                {{ organizationDetails.organisationName }}
              </p>
              <p class="mb-2">
                <strong>Reg No:</strong>
                {{ organizationDetails.companyRegistrationNumber }}
              </p>
              <p class="mb-2">
                <strong>Address:</strong>
                {{ organizationDetails.address }}, {{ organizationDetails.city }},
                {{ organizationDetails.zip }}
              </p>
              <p class="mb-2">
                <strong>Country:</strong>
                {{ organizationDetails.country }}
              </p>
              <p class="mb-2">
                <strong>Contact:</strong>
                {{ organizationDetails.contactPerson }} ({{
                organizationDetails.contactNumber
                }})
              </p>
              <p class="mb-0">
                <strong>Email:</strong>
                {{ organizationDetails.email }}
              </p>
            </div>
          </div>
          <div class="border-top mt-3 pt-3">
            <app-payment-info [(selected)]="isPaymentSelected" [trialDays]="selectedPlans[0].numberOfTrialDays"></app-payment-info>
          </div>
        </div>
      </div>

      <div class="mt-4 text-center d-flex justify-content-between align-items-center"
        *ngIf="formSubmissionStatus === null">
        <dx-button text="Back" icon="arrowleft" type="normal" (onClick)="goBack(null)"></dx-button>
        <button [disabled]="!isPaymentSelected" class="complete-button px-5" (click)="savePlanDetails()">
          Place Order
        </button>
      </div>

      <div class="registration-status mt-3">
        <div class="d-flex h-100 justify-content-center align-items-center gap-3"
          *ngIf="formSubmissionStatus === 'awaiting'">
          <h4 class="fw-bold m-0 text-center">Organization Creation in Progress</h4>
          <mat-spinner class="mat-spinner"></mat-spinner>
          <!-- <h4 class="fw-bold text-center">Please Wait</h4> -->
        </div>

        <div class="d-flex h-100 justify-content-center align-items-center gap-1"
          *ngIf="formSubmissionStatus === 'success'">
          <span class="material-icons" style="color: #1da24f; font-size: 40px; height: 40px">
            check_circle
          </span>
          <h4 class="fw-bold text-center m-0">Organization Successfully Created</h4>
          <dx-button text="Go Home" stylingMode="contained" [style.backgroundColor]="'#0fa2d9'"
            [style.color]="'#ffffff'" class="ms-auto" (onClick)="goToHomePage()"></dx-button>
        </div>

        <div class="d-flex h-100 justify-content-center align-items-center gap-3"
          *ngIf="formSubmissionStatus === 'failure'">
          <span class="material-icons" style="color: #d01301; font-size: 40px; height: 40px">
            cancel
          </span>
          <h4 class="fw-bold text-center m-0">Organization Creation Failed, Please try again later.</h4>
          <!-- <h6 class="text-center m-0">
            Some error occured. Please try again later.
          </h6> -->
          <dx-button text="Go Home" stylingMode="contained" type="danger" class="ms-auto"
            (onClick)="goToHomePage()"></dx-button>
        </div>
      </div>
    </div>
  </ng-container>
</div>